import { QuestionIcon, Text, Tooltip, TrustPaymentIcon } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { PromoItem } from '@beef/smart-kit';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

type PromoInstallmentProps = {
  primaryText: string;
  secondaryText: string;
  tooltipMessage: string;
  tooltipButtonText?: string;
  tooltipButtonHref?: string;
  tooltipButtonOnClick?: () => void;
  isMobile: boolean;
  onOpen?: () => void;
};

export const PromoBnpl: React.FC<PromoInstallmentProps> = ({
  primaryText,
  secondaryText,
  tooltipMessage,
  tooltipButtonText,
  tooltipButtonHref,
  tooltipButtonOnClick,
  isMobile,
  onOpen,
}) => (
  <PromoItem>
    <Tooltip
      onOpen={onOpen}
      message={tooltipMessage}
      buttonConfig={{
        text: tooltipButtonText || '',
        href: !tooltipButtonOnClick ? tooltipButtonHref : undefined,
        onClick: tooltipButtonOnClick,
      }}
      position={isMobile ? 'bottom' : 'left'}
      maxWidth="264"
    >
      <div className={cx('tooltip')}>
        <span className={cx('icon')}>
          <TrustPaymentIcon size={18} />
        </span>
        <Text size="size5-m" className={cx('main-text')}>
          {primaryText}
        </Text>{' '}
        <Text color="grey50" size="size5-r-s" tagType="span">
          {secondaryText}
        </Text>{' '}
        <span>
          <QuestionIcon size="xs" fill="currentColor" />
        </span>
      </div>
    </Tooltip>
  </PromoItem>
);
